<nav
  class="md:hidden fixed bottom-0 left-0 w-full bg-surface shadow-[0px_-4px_20px_rgba(61,26,110,0.05)] border-t border-outline-variant/20 z-50 flex justify-around items-center py-2 px-4"
  data-testid="bottom-nav"
>
  @for (item of navItems(); track item.key) {
    <a
      [routerLink]="item.route"
      routerLinkActive
      #rla="routerLinkActive"
      [class]="
        rla.isActive
          ? 'flex flex-col items-center gap-1 p-2 text-primary font-bold'
          : 'flex flex-col items-center gap-1 p-2 text-on-surface-variant hover:text-primary transition-colors'
      "
    >
      <span class="material-symbols-outlined text-[22px]" [style.font-variation-settings]="rla.isActive ? '\'FILL\' 1' : null">{{ item.icon }}</span>
      <span class="font-label-sm text-label-sm text-[10px]">{{ item.label }}</span>
    </a>
  }
</nav>
